// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Interesting_wrapper__1pb7q","title":"Interesting_title__2u7IQ","wrap":"Interesting_wrap__3Memy","card":"Interesting_card__CTutv","btns":"Interesting_btns__hto04"};